export default __webpack_public_path__ + "static/media/supply_accounts_import_template.4c2d7506.csv";